import { ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-581f6041"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "config_wrap"
};
const _hoisted_2 = {
  key: 0,
  class: "no_config"
};
const _hoisted_3 = {
  class: "no_config_container"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "当前设备未配置独立的测试场景，默认采用通用配置 可为该设备添加独立的测试场景", -1));
const _hoisted_5 = {
  key: 1,
  class: "config_detail_wrapper"
};
const _hoisted_6 = {
  class: "detail_container"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "config_bottom_item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "left_title"
}, "阻塞时长", -1));
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "editor_wrap"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "json_editor_wrap"
};
const _hoisted_15 = {
  class: "btn_wrap"
};
import { message, Empty } from 'ant-design-vue';
import { cloneDeep } from 'lodash';
import { reportEvent } from '@/common';
import JsonEditorVue from 'json-editor-vue3';
import { addTestConfigFetch } from '@/api/sandbox';
export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceConfig',
  props: {
    scenarioList: {
      type: Array,
      defualt: () => []
    },
    configList: {
      type: Array,
      defualt: () => []
    },
    dbtId: {
      type: String
    },
    testObjectType: {
      type: Number
    },
    payChnl: {
      type: String
    },
    deviceId: {
      type: String
    },
    productLoading: {
      type: Boolean,
      defualt: true
    },
    currentMode: {
      type: String,
      defualt: 'tree'
    },
    jsonModelList: {
      type: Array,
      defualt: () => ['tree', 'text', 'code', 'form', 'view']
    }
  },
  setup(__props) {
    const props = __props;
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    const defultJson = {};
    const defaultJsonString = JSON.stringify(defultJson);
    const hasSaved = ref(false); // 当前配置是否保存过
    const loading = ref(false);
    const hasDeviceConfig = ref(false);
    const sceneList = ref([]);
    const configItem = ref();
    const originConfigItem = ref();
    const formatter = value => {
      return `${value} 毫秒`;
    };
    const parser = value => {
      return value.replace(' 毫秒', ''); // 移除“毫秒”后缀
    };
    const operateStopTime = (type, item) => {
      const change = type === 'add' ? 1000 : -1000;
      item.blockTimeMillis = Math.max(0, item.blockTimeMillis + change);
    };
    // const handleJsonChange = (val: object, item: SceneItem) => {
    //   console.log('json对象变更', item, val)
    // }
    const cancleConfig = () => {
      var _configItem$value;
      hideAllCustomJson();
      if (hasDeviceConfig.value && (_configItem$value = configItem.value) !== null && _configItem$value !== void 0 && _configItem$value.testId) {
        // 编辑场景
        // 此时说明已经配置过了，需要恢复到之前的配置
        configItem.value = cloneDeep(originConfigItem.value);
        updateSceneList();
      } else if (hasDeviceConfig.value && hasSaved.value) {
        // 新增的场景
        // 此时说明已经保存过配置，此时暂时什么都不做
      } else {
        hasDeviceConfig.value = false;
      }
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: '测试配置',
          element_name: '取消配置测试场景'
        }
      });
    };
    const changeConfigItem = item => {
      hideAllCustomJson();
      item.showCustomJson = judgeCustom(item);
    };
    // 判断当前选中的是否为自定义
    const judgeCustom = item => {
      var _item$subScenarioDmoL;
      if (!item.choosedSubScenarioId) return false; // 如果没有选中，此时不为自定义
      return ((_item$subScenarioDmoL = item.subScenarioDmoList.find(subItem => subItem.subScenarioId === item.choosedSubScenarioId)) === null || _item$subScenarioDmoL === void 0 ? void 0 : _item$subScenarioDmoL.subScenarioCode) === 'custom';
    };
    const focusConfigItem = item => {
      changeConfigItem(item);
    };
    // 隐藏所有的自定义配置
    const hideAllCustomJson = () => {
      var _sceneList$value;
      (_sceneList$value = sceneList.value) === null || _sceneList$value === void 0 || _sceneList$value.forEach(item => {
        item.showCustomJson = false;
      });
    };
    const showConfigDetail = () => {
      hasDeviceConfig.value = true;
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: '测试配置',
          element_name: '配置测试场景'
        }
      });
    };
    // 整合保存的配置
    const getParams = () => {
      var _sceneList$value2, _configItem$value2;
      // 过滤掉没选中的配置项
      const scenarioConfigList = (_sceneList$value2 = sceneList.value) === null || _sceneList$value2 === void 0 || (_sceneList$value2 = _sceneList$value2.filter(item => item.choosedSubScenarioId)) === null || _sceneList$value2 === void 0 ? void 0 : _sceneList$value2.map(item => {
        const defaultParams = {
          scenarioId: item.scenarioId,
          subScenarioId: item.choosedSubScenarioId,
          networkConfig: {
            blockTimeMillis: item.blockTimeMillis
          }
        };
        const isCustom = judgeCustom(item);
        // 如果是自定义  此时需要传递customizeResponse参数
        if (isCustom) {
          let customizeResponse = defaultJsonString;
          try {
            customizeResponse = JSON.stringify(item.customizeResponse);
          } catch (error) {
            console.error('自定义配置的，JSON字符串格式化失败', error);
          }
          return {
            ...defaultParams,
            customizeResponse
          };
        }
        return {
          ...defaultParams
        };
      });
      const params = {
        testObjectType: props.testObjectType,
        dbtId: props.dbtId,
        payChnl: props.payChnl,
        deviceId: props.deviceId,
        testConfig: {
          scenarioConfigList
        }
      };
      if ((_configItem$value2 = configItem.value) !== null && _configItem$value2 !== void 0 && _configItem$value2.testId) {
        params.testId = configItem.value.testId; // 如果有testId，需要传递给后端
      }
      return params;
    };
    const checkChoosed = () => {
      return sceneList.value.some(item => item.choosedSubScenarioId);
    };
    const saveConfig = async () => {
      if (!checkChoosed()) {
        return message.error('请选择需要配置的测试场景');
      }
      const params = getParams();
      // console.log('保存配置', params)
      try {
        loading.value = true;
        const {
          code
        } = await addTestConfigFetch(params);
        if (code === '0000') {
          hasSaved.value = true; // 保存过置为true
          message.success('配置保存成功');
          hideAllCustomJson();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '测试配置',
              element_name: '配置测试场景成功'
            }
          });
        } else {
          message.error('配置保存失败');
        }
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    };
    // 初始化场景列表数据
    const initSceneList = () => {
      var _props$scenarioList;
      // 过滤掉没有配置二级子场景的场景列表
      if (props.scenarioList && Array.isArray(props.scenarioList) && (_props$scenarioList = props.scenarioList) !== null && _props$scenarioList !== void 0 && _props$scenarioList.length) {
        var _list$filter$map, _list$filter;
        const list = cloneDeep(props.scenarioList);
        sceneList.value = (_list$filter$map = list === null || list === void 0 || (_list$filter = list.filter(item => {
          var _item$subScenarioDmoL2;
          return (_item$subScenarioDmoL2 = item.subScenarioDmoList) === null || _item$subScenarioDmoL2 === void 0 ? void 0 : _item$subScenarioDmoL2.length;
        })) === null || _list$filter === void 0 ? void 0 : _list$filter.map(item => ({
          ...item,
          choosedSubScenarioId: undefined,
          showCustomJson: false,
          customizeResponse: defultJson,
          blockTimeMillis: 0
        }))) !== null && _list$filter$map !== void 0 ? _list$filter$map : [];
      }
    };
    // 更新场景列表数据
    const updateSceneList = () => {
      var _configItem$value$tes, _configItem$value3, _props$scenarioList2;
      const curConfigList = (_configItem$value$tes = (_configItem$value3 = configItem.value) === null || _configItem$value3 === void 0 || (_configItem$value3 = _configItem$value3.testConfig) === null || _configItem$value3 === void 0 ? void 0 : _configItem$value3.scenarioConfigList) !== null && _configItem$value$tes !== void 0 ? _configItem$value$tes : [];
      if (props.scenarioList && Array.isArray(props.scenarioList) && (_props$scenarioList2 = props.scenarioList) !== null && _props$scenarioList2 !== void 0 && _props$scenarioList2.length) {
        var _list$filter2;
        const list = cloneDeep(props.scenarioList);
        sceneList.value = list === null || list === void 0 || (_list$filter2 = list.filter(item => {
          var _item$subScenarioDmoL3;
          return (_item$subScenarioDmoL3 = item.subScenarioDmoList) === null || _item$subScenarioDmoL3 === void 0 ? void 0 : _item$subScenarioDmoL3.length;
        })) === null || _list$filter2 === void 0 ? void 0 : _list$filter2.map(item => {
          var _curConfig$networkCon, _curConfig$networkCon2;
          const curConfig = curConfigList.find(configItem => configItem.scenarioId === item.scenarioId);
          const curSubScenarioId = curConfig === null || curConfig === void 0 ? void 0 : curConfig.subScenarioId;
          const blockTimeMillis = (_curConfig$networkCon = curConfig === null || curConfig === void 0 || (_curConfig$networkCon2 = curConfig.networkConfig) === null || _curConfig$networkCon2 === void 0 ? void 0 : _curConfig$networkCon2.blockTimeMillis) !== null && _curConfig$networkCon !== void 0 ? _curConfig$networkCon : 0;
          let curCustomizeResponse = defultJson;
          try {
            var _curConfig$customizeR;
            curCustomizeResponse = JSON.parse((_curConfig$customizeR = curConfig === null || curConfig === void 0 ? void 0 : curConfig.customizeResponse) !== null && _curConfig$customizeR !== void 0 ? _curConfig$customizeR : defaultJsonString);
          } catch (error) {
            console.error('JSON.parse  customizeResponse  失败', error);
          }
          return {
            ...item,
            choosedSubScenarioId: curSubScenarioId,
            showCustomJson: false,
            customizeResponse: curCustomizeResponse,
            blockTimeMillis
          };
        });
      }
    };
    watch(() => props.configList, newVal => {
      if (newVal && Array.isArray(newVal)) {
        hasSaved.value = false; // 每次置为false
        if (newVal.length > 0) {
          var _newVal$;
          hasDeviceConfig.value = true;
          configItem.value = originConfigItem.value = (_newVal$ = newVal === null || newVal === void 0 ? void 0 : newVal[0]) !== null && _newVal$ !== void 0 ? _newVal$ : {};
          updateSceneList();
        } else {
          hasDeviceConfig.value = false;
          configItem.value = originConfigItem.value = {};
          initSceneList();
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_spin, {
        spinning: __props.productLoading
      }, {
        default: _withCtx(() => [__props.dbtId ? (_openBlock(), _createElementBlock("div", _hoisted_1, [!hasDeviceConfig.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_a_button, {
          onClick: showConfigDetail,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("配置测试场景")]),
          _: 1
        })])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.scenarioId,
            class: "detail_item"
          }, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.scenarioName), 1), _createVNode(_component_a_radio_group, {
            value: item.choosedSubScenarioId,
            "onUpdate:value": $event => item.choosedSubScenarioId = $event,
            onChange: $event => changeConfigItem(item)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subScenarioDmoList, temp => {
              return _openBlock(), _createBlock(_component_a_radio, {
                key: temp.subScenarioId,
                value: temp.subScenarioId,
                onFocus: $event => focusConfigItem(item)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(temp.subScenarioName), 1)]),
                _: 2
              }, 1032, ["value", "onFocus"]);
            }), 128))]),
            _: 2
          }, 1032, ["value", "onUpdate:value", "onChange"]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_input_number, {
            value: item.blockTimeMillis,
            "onUpdate:value": $event => item.blockTimeMillis = $event,
            min: 0,
            precision: 0,
            style: {
              "width": "200px"
            },
            formatter: formatter,
            parser: parser
          }, {
            addonBefore: _withCtx(() => [_createElementVNode("div", {
              class: "operate_btn",
              onClick: $event => operateStopTime('plus', item)
            }, "-", 8, _hoisted_10)]),
            addonAfter: _withCtx(() => [_createElementVNode("div", {
              class: "operate_btn",
              onClick: $event => operateStopTime('add', item)
            }, "+", 8, _hoisted_11)]),
            _: 2
          }, 1032, ["value", "onUpdate:value"])]), _createVNode(_Transition, {
            name: "horizontal-slide-right"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, "【" + _toDisplayString(item.scenarioName) + "】自定义返回", 1), _createElementVNode("div", _hoisted_14, [_createVNode(_unref(JsonEditorVue), {
              modelValue: item.customizeResponse,
              "onUpdate:modelValue": $event => item.customizeResponse = $event,
              modeList: __props.jsonModelList,
              currentMode: 'code',
              language: "zh"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "modeList"])])], 512), [[_vShow, item.showCustomJson]])]),
            _: 2
          }, 1024)]);
        }), 128)), _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_button, {
          onClick: saveConfig,
          class: "save_btn",
          loading: loading.value,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("保存配置")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_a_button, {
          onClick: cancleConfig,
          class: "cancle_btn",
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }, 8, ["loading"])])])]))])) : (_openBlock(), _createBlock(_unref(Empty), {
          key: 1,
          class: "no_dbtId",
          image: _unref(simpleImage),
          description: "请优先选择产品"
        }, null, 8, ["image"]))]),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});